<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="sp" id="ded"> </p>
<p class="DED"><span epub:type="pagebreak" id="pg_v" title="v"><span class="ePub-I">Dedicated to my teachers, and in memory of the first and best of them, my father, Theodore Blunk</span></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?c4ed461a